import {AxiosResponse} from "axios";
import * as React from "react";
import {HttpError} from "../../../../../common/components/shared/httpError/httpError";
import {Popup} from "../../../../../common/components/shared/popup/popup";
import {HttpErrorModel} from "../../../../../common/models/httpError";
import {Api} from "../../../../../helpers/api";
import i18n from "../../../../../i18n/i18n";
import {ReactComponent as ActiveIcon} from "../../../../../statics/icons/icon_active_route.svg";
import {ReactComponent as InactiveIcon} from "../../../../../statics/icons/icon_inactive_route.svg";

interface ActiveOrInactivePopupProps {
    action: "active" | "inactive" | null;
    routeName: string;
    displayPopup: boolean;
    confirm: () => void;
    closePopup: () => void;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    isWaiting?: boolean;
}

export default function ActiveOrInactivePopup(props: ActiveOrInactivePopupProps): React.ReactElement {
    const isActiveAction = props.action === "active";
    let classAndTestIdName = "";
    let header = "";
    let secondHeader = "";
    let icon = <></>;
    let content = <></>;
    let actionText = "";
    let errorSuffix = "";

    if (isActiveAction) {
        classAndTestIdName = "active-popup";
        header = i18n.t("topology.routes.actions.activePopup.header");
        secondHeader = i18n.t("topology.routes.actions.activePopup.secondHeader");
        icon = <ActiveIcon/>;
        content = (
            <div>
                {i18n.t("topology.routes.actions.activePopup.contentPart1")}
                <b>{props.routeName}</b>
                {i18n.t("topology.routes.actions.activePopup.contentPart2")}
            </div>
        );
        actionText =  i18n.t("topology.routes.actions.activePopup.actionText");
        errorSuffix = i18n.t("topology.routes.actions.activePopup.errorSuffix");
    } else {
        classAndTestIdName = "inactive-popup";
        header = i18n.t("topology.routes.actions.inactivePopup.header");
        secondHeader = i18n.t("topology.routes.actions.inactivePopup.secondHeader");
        icon = <InactiveIcon/>;
        content = (
            <div>
                {i18n.t("topology.routes.actions.inactivePopup.contentPart1")}
                <b>{props.routeName}</b>
                {i18n.t("topology.routes.actions.inactivePopup.contentPart2")}
            </div>
        );
        actionText =  i18n.t("topology.routes.actions.inactivePopup.actionText");
        errorSuffix = i18n.t("topology.routes.actions.inactivePopup.errorSuffix");
    }

    return (
        <Popup
            open={props.displayPopup}
            className={!isActiveAction ? `${classAndTestIdName} popup-with-secondary-button-color` : classAndTestIdName}
            header={header}
            secondHeader={secondHeader}
            icon={icon}
            content={content}
            actionText={actionText}
            action={props.confirm}
            cancel={props.closePopup}
            testId={classAndTestIdName}
            isWaiting={props.isWaiting}
            httpError={
                <>
                    {!Api.isSuccess(props.response) && (
                        <HttpError
                            response={props.response}
                            cause={errorSuffix}
                        />
                    )}
                </>
            }
        />
    );
}
